import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Row, Button, ToggleButton, ToggleButtonGroup, Col,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

export default class QuizScreen extends React.Component {
    constructor(props) {
        super(props);
        this.filterChange = this.filterChange.bind(this);
        this.filterCleanup = this.filterCleanup.bind(this);
        this.pageChangeHandler = this.pageChangeHandler.bind(this);
        this.refreshState = this.refreshState.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.state = {
            filter: {},
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
        };
        this.API_ENDPOINT = 'quiz/?';
        this.API_ENDPOINT_QS = '';
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${event.currentTarget.dataset.name || ''}?`)) {
            Fetcher(`quiz/${event.currentTarget.id}/`, 'DELETE', this.refreshState);
        }
    }

    columns = [
        {
            Header: 'Код',
            accessor: 'id',
            maxWidth: 200,
            Cell: (row) => (
                <div align="center">
                    [quiz]
                    {row.value}
                    [/quiz]
                </div>
            ),
        },
        {
            Header: 'Название',
            accessor: 'title',
            minWidth: 430,
            Cell: (row) => (
                <div>
                    <Link
                        to={`${PROJECT_PREFIX}/quiz/${row.row.id}/edit`}
                    >
                        {row.value}
                    </Link>
                </div>
            ),
        }, {
            Header: '',
            accessor: 'id',
            maxWidth: 40,
            Cell: (row) => (
                <Button size="sm" variant="link" id={row.value} data-name={row.original.name} to="#" onClick={this.removeItemHandler}>
                    <FontAwesomeIcon id={row.value} icon="trash" />
                </Button>
            ),
        },
    ];

    filterChange(event) {
        const filter_params = this.state.filter;
        const key = event.currentTarget.id;
        let { value } = event.currentTarget;

        if (event.currentTarget.type === 'checkbox') {
            value = event.currentTarget.checked;
        }

        filter_params[key] = value;
        this.setState({ filter: filter_params });

        let result_qs = '';

        for (let i = 0; i < Object.keys(filter_params).length; i++) {
            const key = Object.keys(filter_params)[i];
            result_qs += `&${key}=${filter_params[key]}`;
        }

        this.API_ENDPOINT_QS = result_qs;
    }

    filterCleanup() {
        this.API_ENDPOINT_QS = '';
        this.setState({ filter: {} });
    }

    pageChangeHandler(data) {
        this.props.history.push(`${PROJECT_PREFIX}/${data}/all`);
    }

    render() {
        return (
            <div className="container-fluid">
                <Row className="mb-2">
                    <Col md={12}>
                        <NewEntityButton to="/quiz/new" />
                    </Col>
                </Row>
                <Row>
                    <ToggleButtonGroup
                        value="quiz"
                        name="pageType"
                        key="inlineStyleBlock"
                        type="radio"
                        onChange={this.pageChangeHandler}
                    >
                        <ToggleButton variant="outline-secondary" value="quiz_trivia"> Викторины </ToggleButton>
                        <ToggleButton variant="outline-secondary" value="quiz"> Тесты </ToggleButton>
                        <ToggleButton variant="outline-secondary" value="poll"> Опросы </ToggleButton>
                    </ToggleButtonGroup>
                </Row>
                <Row>
                    <TableScreenWithoutUpdate
                        columns={this.columns}
                        endpoint={this.API_ENDPOINT + this.API_ENDPOINT_QS}
                    />
                </Row>
            </div>
        );
    }
}
